import * as React from "react";
import { TextField, type ITextFieldStyles } from "@fluentui/react/lib/TextField";
import type { LtlFormCapabilities } from "@src/types/api";
import { ltlFieldInputId } from "@taskpane/utils/ltlValidationFocus";
import type { BolDetailsFormValues } from "./bolDetailsFormTypes";

interface BolDetailsTrailingFieldsProps {
  form: BolDetailsFormValues;
  errors: Record<string, string>;
  caps: LtlFormCapabilities;
  onFieldChange: (name: keyof BolDetailsFormValues, value: string) => void;
  handleInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  onFieldBlur?: () => void;
  gfs: (fieldName: keyof BolDetailsFormValues) => Partial<ITextFieldStyles>;
}

export function BolDetailsTrailingFields({
  form,
  errors,
  caps,
  onFieldChange,
  handleInputChange,
  onFieldBlur,
  gfs,
}: BolDetailsTrailingFieldsProps): React.ReactElement {
  return (
    <>
      <TextField
        label="PO #"
        name="poNumber"
        value={form.poNumber ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("poNumber")}
        styles={gfs("poNumber") as ITextFieldStyles}
        errorMessage={errors.poNumber}
      />
      <TextField
        label="Notes"
        name="billOfLadingNote"
        value={form.billOfLadingNote ?? ""}
        onChange={(_, newValue) => onFieldChange("billOfLadingNote", newValue ?? "")}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("billOfLadingNote")}
        styles={gfs("billOfLadingNote") as ITextFieldStyles}
        multiline
        autoAdjustHeight
      />
      <TextField
        label="Shipper Number"
        name="shipperNumber"
        value={form.shipperNumber ?? ""}
        onChange={handleInputChange}
        onBlur={onFieldBlur}
        id={ltlFieldInputId("shipperNumber")}
        styles={gfs("shipperNumber") as ITextFieldStyles}
        errorMessage={errors.shipperNumber}
      />
      {caps.showShipperConsigneeContact && (
        <>
          <TextField
            label="Shipper Contact"
            name="shipperContact"
            value={form.shipperContact ?? ""}
            onChange={handleInputChange}
            onBlur={onFieldBlur}
            id={ltlFieldInputId("shipperContact")}
            styles={gfs("shipperContact") as ITextFieldStyles}
          />
          <TextField
            label="Shipper Phone"
            name="shipperPhone"
            value={form.shipperPhone ?? ""}
            onChange={handleInputChange}
            onBlur={onFieldBlur}
            id={ltlFieldInputId("shipperPhone")}
            styles={gfs("shipperPhone") as ITextFieldStyles}
          />
          <TextField
            label="Consignee Contact"
            name="consigneeContact"
            value={form.consigneeContact ?? ""}
            onChange={handleInputChange}
            onBlur={onFieldBlur}
            id={ltlFieldInputId("consigneeContact")}
            styles={gfs("consigneeContact") as ITextFieldStyles}
          />
          <TextField
            label="Consignee Phone"
            name="consigneePhone"
            value={form.consigneePhone ?? ""}
            onChange={handleInputChange}
            onBlur={onFieldBlur}
            id={ltlFieldInputId("consigneePhone")}
            styles={gfs("consigneePhone") as ITextFieldStyles}
          />
        </>
      )}
    </>
  );
}
